import PropTypes from 'prop-types';

const ImgViewer = ({ url }) => {
  return (
    <figure className="p-3">
      <img className="w-screen rounded-lg" src={url} alt="Education material" />
    </figure>
  );
};

/**
 * Component definition of proptypes
 */
ImgViewer.propTypes = {
  url: PropTypes.string.isRequired
};

export default ImgViewer;
